
export default {
  global:{}
}



// WEBPACK FOOTER //
// ./src/components/global/common.js